<template>
  <div class="py-4 container-fluid">
    <div class="row pb-0">
      <div class="col-auto pb-0"><h4 class="h4 font-weight-bold text-left text-capitalize mb-0">Dashboard</h4></div>
      <div class="col-auto pb-0" v-if="isSystemAdmin || isBldgAdmin">
        <button type="button" class="btn btn-sm tnkc-success px-2"  v-on:click="pendingOnBooking">
        Pending Crew/s <b>For Booking: {{countForBooking}}</b>
      </button>
      </div>
    </div>
    <hr />
    <div  v-if="isSystemAdmin || isBldgAdmin " class="row py-0">
      <div class="col-md-4" v-for="(room,index) in roomsThisWeek" :key="room.index">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th class="tnkc-primary" scope="col" colspan="2">Available Rooms ( {{room.name.toUpperCase()}} )</th>
            </tr>
            <tr>
              <th scope="col" width="">Date</th>
              <th scope="col" width="100">Rooms</th>
              <th scope="col" width="100">Beds</th>
            </tr>
          </thead>
            <tbody style="height: 220px;">
              <tr v-for="(data,index) in room.data" :key="data.index">
                <td class="p-1">
                  <span class="p-1">{{data.date | moment('D MMM YYYY')}}</span>
                  <span class="ml-1 font-weight-bold small">({{data.day_name}})</span>
                </td>
                <td width="100">{{data.room_count}}</td>
                <td width="100">{{data.bed_count}}</td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>

    <div class="row py-4">
      <div class="col-md-5" v-for="checkOut in checkOutThisWeek">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th class="tnkc-primary-dark" scope="col" colspan="3">
                SCHEDULED CHECK-OUT FOR
              <small class=" font-weight-bold">( {{checkOut.data.start_week_today |  moment("DD MMM YYYY")}} -
                     {{checkOut.data.end_week_today |  moment("DD MMM YYYY")}} )</small>
              </th>
            </tr>
            <tr class="font-weight-bold">{{checkOut.hotel.toUpperCase()}}</tr>
            <tr>
              <th scope="col" class="p-1">Date</th>
              <th scope="col" class="p-1">Name</th>
              <th scope="col" class="p-1" width="80">Rank</th>
            </tr>
          </thead>
          <tbody style="height: 200px;">
              <tr v-for="(value,index) in checkOut.data.check_out_week" :key="value.index">
                <td>
                  <span>{{value.booked_check_out | moment("DD MMM YYYY")}}</span>
                  <span class="ml-1 font-weight-bold small">({{value.day_name}})</span>
                </td>
                <td class="p-1 text-left">
                  <button class="btn btn-xsm" @click="viewProfile(value.crew_id)" title="Click to view profile"  v-bind:class="nameBgClass(value)">
                    <u>{{titleCase(value.crew)}} <span>{{ addNeedAttention(value) }}</span></u>
                  </button>
                <td class="p-1" width="80">{{value.rank}}</td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5" v-for="checkIn in checkInThisWeek">
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th class="tnkc-primary-dark" scope="col" colspan="3">
             BOOKED CHECK-IN AS OF
              <small class=" font-weight-bold">( {{checkIn.data.start_week_today |  moment("DD MMM YYYY")}} - {{checkIn.data.end_week_today |  moment("DD MMM YYYY")}} )</small>
            </th>
          </tr>
          <tr class="font-weight-bold">{{checkIn.hotel.toUpperCase()}}</tr>
            <tr>
              <th scope="col" class="p-1">Date</th>
              <th scope="col" class="p-1">Name</th>
              <th scope="col" class="p-1" width="80">Rank</th>
            </tr>
          </thead>
            <tbody style="height: 200px;">
              <tr v-for="(value,index) in checkIn.data.check_in_week" :key="value.index">
                <td>
                  <span>{{value.booked_check_in | moment("DD MMM YYYY")}}</span>
                  <span class="font-weight-bold ml-1 small">({{value.day_name}})</span>
                </td>
                <td class="p-1 text-left">
                  <button class="btn btn-xsm" @click="viewProfile(value.crew_id)" title="Click to view profile">
                    <u>{{titleCase(value.crew)}}</u>
                  </button>
                </td>
                <td class="p-1" width="80">{{value.rank}}</td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>


    <div class="row">
      <div class="col-md-5" >
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th class="tnkc-primary-dark" scope="col" colspan="3">
             ENDORSED AS OF
              <small class=" font-weight-bold">( {{endorseThisWeek.start_week_today |  moment("DD MMM YYYY")}} - {{endorseThisWeek.end_week_today |  moment("DD MMM YYYY")}} )</small>
            </th>
          </tr>
          <tr>
            <th scope="col" class="p-1">Date</th>
            <th scope="col" class="p-1">Name</th>
            <th scope="col" class="p-1" width="80">Rank</th>
          </tr>
          </thead>
          <tbody style="height: 200px;">
            <tr v-for="(endorse,index) in endorseThisWeek.endorse_this_week" :key="endorse.index">
              <td>
                <span>{{endorse.endorsed_check_in | moment("DD MMM YYYY")}}</span>
                <span class="font-weight-bold ml-1 small">({{endorse.day_name}})</span>
              </td>
              <td class="p-1 text-left">
                <button class="btn btn-xsm" @click="viewProfile(endorse.crew_id)" title="Click to view profile">
                  <u>  {{titleCase(endorse.crew)}}</u>
                </button>
              </td>
              <td class="p-1" width="80">{{endorse.rank}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapActions,mapGetters} from 'vuex';
  import {appMixins} from '../../mixins/app.mixins';
  import {formMixins} from '@/mixins/formMixins';
  export default {
    name: 'Dashboard1',
    mixins:[appMixins,formMixins],
    data(){
      return{
        //return
      }
    },

    methods:{
      ...mapActions(['getRoomsAvailableThisWeek','getCheckOutThisWeek','getCheckInThisWeek','getEndorseThisWeek','getCountForBooking','getCrewForReservation','setParamsNull']),

      getAllData(){
        this.getRoomsAvailableThisWeek();
        this.getCheckOutThisWeek();
        this.getCheckInThisWeek();
        this.getEndorseThisWeek();
      },

      viewProfile(id){
        this.$router.push({name: 'CrewProfile', params: {id: id}});
      },

      nameBgClass(obj = null){
        if(obj.is_overStayed == true){
          return 'isOverstay';
        }
      },

      addNeedAttention(obj = null){
        if(obj.is_overStayed == true){
          return '( Need Attention )';
        }
      },

      pendingOnBooking(){
        //todo. set the parameter into CrewReservation
        this.reservationParams.status = '';
        this.reservationParams.page = 1;
        this.reservationParams.status = 1;
        this.getCrewForReservation(this.reservationParams);
        this.$router.push({name: 'CrewRsrvList'});
      }
    },

    computed:{
      ...mapGetters(['roomsThisWeek','checkOutThisWeek','checkInThisWeek','endorseThisWeek','countForBooking','reservationParams','reservations']),
    },

    created() {
      this.getRoomsAvailableThisWeek();
      this.getCheckOutThisWeek();
      this.getCheckInThisWeek();
      this.getEndorseThisWeek();
      this.getCrewForReservation();

      this.timer = setInterval(() => {
        this.getAllData();
      }, 60000);

      this.getCountForBooking();
    },

    mounted() {
      console.log(this.authUser);
    },

    destroyed() {
      clearInterval(this.timer);
      this.setParamsNull();
    }
  };
</script>

<style scoped>
  .btn-xsm, .btn-group-xsm > .btn {
    padding: 0.20rem 0.2rem !important;
    font-size: 0.870rem !important;
    line-height: 1 !important;
    border-radius: 0.25rem !important;
  }


  u:hover,
  u:focus {
    color: #2c82c9 !important;
    color: #4a4f54;
  }

  table {
    display: flex;
    flex-flow: column;
    width: 100%;

  }

  thead {
    flex: 0 0 auto;
  }

  tbody {
    flex: 1 1 auto;
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
  }

  tr {
    width: 100%;
    display: table;
    table-layout: fixed;
  }
  .tnkc-primary {
    background-color: #89ceff;
    color: #4a4f54;
  }
</style>
